import { render, staticRenderFns } from "./SessionItemDescription.vue?vue&type=template&id=e1a607ee"
import script from "./SessionItemDescription.vue?vue&type=script&lang=js"
export * from "./SessionItemDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports